module.exports = "<div id=\"venue-book\">\n  <a class=\"close\" href=\"#\" ng-click=\"cancel($event)\">\n    <i class=\"fa fa-times\"></i>\n  </a>\n  <div class=\"venue-book-widget\">\n    <div id=\"inventory-list-modal-widget\">\n    </div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/services/modal/bookingWidget/bookingWidgetModal.html
// module id = 870
// module chunks = 1